var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInfoIconBulk(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.85963 4.16666H7.19775V4.49999H6.85963V4.16666ZM6.85963 6.83332H7.19775V9.83332H6.85963V6.83332Z",
    fill: "#323232",
    stroke: "#EF3061"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.83812 7.00001C0.83812 3.59784 3.60995 0.833344 7.0287 0.833344C10.4474 0.833344 13.2193 3.59784 13.2193 7.00001C13.2193 10.4022 10.4474 13.1667 7.0287 13.1667C3.60995 13.1667 0.83812 10.4022 0.83812 7.00001ZM1.17623 7.00001C1.17623 10.2178 3.8037 12.8333 7.0287 12.8333C10.2537 12.8333 12.8812 10.2178 12.8812 7.00001C12.8812 3.78218 10.2537 1.16668 7.0287 1.16668C3.8037 1.16668 1.17623 3.78218 1.17623 7.00001Z",
    fill: "#323232",
    stroke: "#EF3061"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIconBulk);
export default __webpack_public_path__ + "static/media/info_icon_bulk.21053fe18dd64f7044d08fe92eb0fbf5.svg";
export { ForwardRef as ReactComponent };